import { useState } from 'react';
import InputSearch from '/src/components/UI/InputSearch/InputSearch';
import './ConversationLogsModalVariablesDetails.css'
import ConversationLogVariable from './ConversationLogVariable/ConversationLogVariable';
const ConversationLogsModalVariablesDetails = ({ data }) => {
    const [searchTerm, setSearchTerm] = useState('');

    let variablesJSON = [];
    try {
        variablesJSON = JSON.parse(data.logs)?.variables ?? [];
    } catch (error) {
        variablesJSON = [];
    }

    let variables = Object.keys(variablesJSON).map((key) => [key, variablesJSON[key]]);
    variables = variables.sort((a, b) => a[0].localeCompare(b[0]));
    const filteredVariables = variables.filter(([key]) =>
        key.toLowerCase().includes(searchTerm.trim().toLowerCase())
    );

    return (
        <div className="conversation-variables-details">
            <div className="conversation-variables-search">
                <InputSearch
                    placeholderLibelle="variable"
                    onChange={(event) => setSearchTerm(event.target.value)}
                    style={{ minWidth: '300px' }}
                />
            </div>
            <div className="grid_container_conversation_variables_fields">
                {
                    filteredVariables.map((variable, i) =>
                        <ConversationLogVariable key={i} variable={variable} />
                    )
                }
            </div>
        </div>
    );
};

export default ConversationLogsModalVariablesDetails;